<template>
  <v-container fluid>
    <v-card flat class="mx-auto users--top">
      <v-card-title>
        <span>All Users</span>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          class="mx-3"
          dense
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          class="elevation-0 users--table"
          :server-items-length="totalUsers"
          :options.sync="options"
        >
          <template v-slot:item.email_verified_at="{ item }">
            <v-chip
              label
              :color="
                item.email_verified_at ? 'green lighten-4' : 'red lighten-4'
              "
            >
              <v-icon v-if="item.email_verified_at" color="green"
                >mdi-check</v-icon
              >
              <v-icon v-else color="red">mdi-close</v-icon>
              <span
                :class="
                  item.email_verified_at
                    ? 'green--text text--darken-4'
                    : 'red--text text--darken-4'
                "
                >{{
                  item.email_verified_at ? "Verified" : "Not Verified"
                }}</span
              >
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn
                small
                class="mr-2 blue white--text text-capitalize"
                @click="editItem(item)"
              >
                <v-icon small> mdi-pencil </v-icon>
                edit
              </v-btn>
              <v-btn
                small
                class="mr-2 error text-capitalize"
                @click="deleteItem(item)"
              >
                <v-icon small> mdi-pencil </v-icon>
                delete
              </v-btn>
              <v-btn
                small
                class="mr-2 indigo white--text text-capitalize"
                @click="sendPasswordReset(item)"
              >
                <v-icon small> mdi-send-circle-outline </v-icon>
                Send Password Reset Link
              </v-btn>
              <v-btn
                class="mr-2 primary text-capitalize"
                small
                v-if="!item.is_admin && !item.is_approver"
                @click="loginAs(item)"
              >
                <v-icon small> mdi-login-variant </v-icon>
                login as profile {{ item.profile_id }}
              </v-btn>
              <v-btn
                class="mr-2 text-capitalize"
                color="info"
                small
                v-if="
                  !item.is_admin && !item.is_approver && !item.hasNoApplication
                "
                @click="checkProfileApplication(item)"
                text
              >
                <span style="text-decoration: underline"
                  >Check application</span
                >
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <AdminUserDialog :dialog="dialog" :user="user" @close="closeDialog" />
    <UserApplicationDialog
      :applicationDialog="applicationDialog"
      :applications="applications"
      :user="user"
      @closeApplicationDialog="closeUserApplicationdialog"
      @createNewProfileApplication="createApplication"
      :loading="loading"
    />
  </v-container>
</template>
<script>
import AdminUserDialog from "../components/AdminUserDialog.vue";
import UserApplicationDialog from "../components/UserApplicationDialog.vue";
export default {
  name: "AdminUsers",
  components: {
    AdminUserDialog,
    UserApplicationDialog,
  },
  data() {
    return {
      dialog: false,
      user: {},
      applications: [],
      search: "",
      tableRef: 0.3,
      applicationDialog: false,
      loading: false,
      options: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Admin/getUsers", { limit: 10 });
    });
  },
  mounted() {
    setInterval(() => {
      this.tableRef = Math.random();
    }, 1000);
  },
  computed: {
    users: {
      get() {
        return this.$store.getters["Admin/adminGetters"]("users");
      },
    },
    totalUsers: {
      get() {
        return this.$store.getters["Admin/adminGetters"]("total");
      },
    },
    perPage: {
      get() {
        return this.$store.getters["Admin/adminGetters"]("per_page");
      },
    },
    currentPage: {
      get() {
        return this.$store.getters["Admin/adminGetters"]("current_page");
      },
    },
    settings() {
      return this.$store.getters["Admin/adminGetters"]("settings");
    },
    headers() {
      return [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "email Verified",
          value: "email_verified_at",
        },
        {
          text: "Profile Id",
          value: "profile_id",
        },
        {
          text: "ID Number",
          value: "id_number",
        },
        {
          text: "phone number",
          value: "phone_no",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    options: {
      handler(options) {
        if (Object.keys(options).length) {
          const { itemsPerPage, page } = options;

          const isAll = itemsPerPage === -1;
          const same_limit = itemsPerPage === this.perPage;
          const isNextPage = page - this.currentPage === 1;
          const isPrevious = this.currentPage - page === 1;

          if (!same_limit && !isAll) {
            this.$store.dispatch("Admin/getUsers", { limit: itemsPerPage });
          }

          if (same_limit && isNextPage) {
            this.$store.dispatch("Admin/getUsers", {
              limit: itemsPerPage,
              page,
            });
          }

          if (same_limit && isPrevious) {
            this.$store.dispatch("Admin/getUsers", {
              limit: itemsPerPage,
              page,
            });
          }

          if (isAll) {
            this.$store.dispatch("Admin/getUsers", { limit: this.totalUsers });
          }
        }
      },
      deep: true,
    },
    search: {
      handler() {
        setTimeout(this.searchUsers, 1000);
      },
    },
  },
  methods: {
    searchUsers() {
      if (this.search?.trim() !== "") {
        this.$store.dispatch("Admin/getUsers", {
          limit: this.perPage,
          q: this.search.trim(),
        });
      } else {
        this.$store.dispatch("Admin/getUsers", { limit: this.perPage });
      }
    },
    checkProfileApplication(item) {
      this.loading = true;
      if (item && !Object.values(item).length) return;
      this.user = item;
      this.$store
        .dispatch("Admin/checkPrfoileApplication", {
          ProfileID: item.profile_id,
        })
        .then((response) => {
          if (
            !Array.isArray(response.data.data) ||
            !response.data.data.length
          ) {
            this.applications = [];
          } else {
            this.applications = response.data.data;
          }
          this.applicationDialog = true;
          this.loading = false;
          this.$store.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          this.loading = false;
          Event.$emit(
            "ApiError",
            error?.response?.data?.message || error.message
          );
          this.$store.commit("SET_LOADING", false, { root: true });
        });
    },
    createApplication() {
      this.loading = true;
      this.$store
        .dispatch("Admin/createNewProfileApplication", {
          ProfileID: this.user.profile_id,
          AppliedCategory: this.user.category,
          ApplicationDateTime: new Date(),
          Charge_Item: "APP",
        })
        .then(() => {
          this.loading = false;
          this.$store.commit("SET_LOADING", false, { root: true });
          this.checkProfileApplication(this.user);
        })
        .catch((error) => {
          this.loading = false;
          Event.$emit(
            "ApiError",
            error?.response?.data?.message || error.message
          );
          this.$store.commit("SET_LOADING", false, { root: true });
        });
    },
    editItem(item) {
      this.dialog = true;
      this.user = item;
    },
    deleteItem(item) {
      this.$store.dispatch("Admin/deleteUser", item);
    },
    closeDialog() {
      this.dialog = false;
      this.user = {};
    },
    sendPasswordReset(item) {
      this.$confirm.show({
        title: "Send Password Reset Link?",
        text: "Are you sure you want to send a password reset link to this user?",
        onConfirm: () => {
          this.$store.dispatch("Admin/sendPasswordReset", item);
        },
      });
    },
    loginAs(item) {
      this.$confirm.show({
        title: `Login As ${item.profile_id}`,
        text: "Are you sure you want to login as this user?",
        onConfirm: () => {
          this.$store.dispatch("Admin/loginAs", item);
        },
      });
    },
    closeUserApplicationdialog(arg) {
      this.applicationDialog = arg;
    },
  },
};
</script>
<style>
/**.users--table {
    height: 60vh;
    overflow-y: scroll;
  }*/
.users--top > .v-card__title {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
}
</style>
